/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Line_TotalInputs */

const en_orders_line_total = /** @type {(inputs: Orders_Line_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Total`)
};

const es_orders_line_total = /** @type {(inputs: Orders_Line_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de linea`)
};

/**
* | output |
* | --- |
* | "Line Total" |
*
* @param {Orders_Line_TotalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_line_total = /** @type {((inputs?: Orders_Line_TotalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Line_TotalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_line_total(inputs)
	return es_orders_line_total(inputs)
});